export default __webpack_public_path__ + "static/media/gallery_12.ad275afa.jpg";